import styled from 'styled-components';
import { LinkButton } from '../button';

export const StyledVoucherField = styled.div`
  display: inline-block;

  .field {
    display: inline-block;
    width: 150px;

    & > span {
      border-radius: ${props => props.theme.borderRadius} 0 0 ${props => props.theme.borderRadius};
      display: inline-block;
    }
  }

  button {
    position: relative;
    top: -2px;
    left: -1px;
    border-radius: 0 ${props => props.theme.borderRadius} ${props => props.theme.borderRadius} 0;
  }
`

export const StyledRemoveVoucherLink = styled(LinkButton)`
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -2px;
  text-transform: lowercase;
`
